/* FWL_MOBILE_LEASE_NORMALIZER_V3 — unpublished 365 theme only */
(() => {
  document.documentElement.setAttribute('data-fwl-mobile-lease-guard', 'v3');
  const approvedDisclosure = 'DOWN PAYMENT + 52 WEEKLY PAYMENTS WILL NOT EXCEED THE SELLING PRICE.';
  const rejectedExact = new Set(['EACH', 'INTEREST', '0%']);
  const rejectedTotalLabels = [
    'TOTAL COST AFTER ALL PAYMENTS',
    'TOTAL OF DOWN PAYMENT AND 52 WEEKLY PAYMENTS'
  ];
  const legacySignals = [
    'CASH PRICE',
    'INITIAL PAYMENT',
    'TOTAL COST AFTER ALL PAYMENTS',
    'YOUR PAYMENTS EQUAL THE CASH PRICE'
  ];

  const compact = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const ownText = (element) => compact(Array.from(element.childNodes)
    .filter((node) => node.nodeType === Node.TEXT_NODE)
    .map((node) => node.textContent)
    .join(' '));

  const removeTotalGroup = (labelElement, box) => {
    let candidate = labelElement;
    while (candidate.parentElement && candidate.parentElement !== box) {
      const parent = candidate.parentElement;
      const text = compact(parent.textContent);
      if (/SELLING PRICE|10% DOWN|52 WEEKLY PAYMENTS/.test(text)) break;
      candidate = parent;
      if (/\$\s*[\d,]+\.\d{2}/.test(text)) break;
    }
    const sibling = labelElement.nextElementSibling;
    candidate.remove();
    if (sibling && /^\$\s*[\d,]+\.\d{2}$/.test(compact(sibling.textContent))) {
      sibling.remove();
    }
  };

  const removeLegacyMobileBoxes = (root) => {
    const candidates = new Set();
    Array.from(root.querySelectorAll('*')).forEach((element) => {
      if (!legacySignals.includes(ownText(element))) return;
      let candidate = element;
      while (candidate.parentElement && candidate.parentElement !== document.body) {
        const text = compact(candidate.textContent);
        const signalCount = legacySignals.filter((signal) => text.includes(signal)).length;
        if (signalCount >= 3 && /\$\s*[\d,]+\.\d{2}/.test(text) && text.length < 1400) {
          candidates.add(candidate);
          break;
        }
        candidate = candidate.parentElement;
      }
    });
    Array.from(candidates).forEach((candidate) => {
      if (!candidate.isConnected || candidate.closest('[data-local-deals-lease]')) return;
      const text = compact(candidate.textContent);
      if (legacySignals.filter((signal) => text.includes(signal)).length >= 3) candidate.remove();
    });
  };

  window.fwlNormalizeMobileLease = (root = document, force = false) => {
    if (!force && !window.matchMedia('(max-width: 749px)').matches) return;

    removeLegacyMobileBoxes(root);

    root.querySelectorAll('[data-local-deals-lease]').forEach((box) => {
      box.hidden = false;
      box.style.removeProperty('display');

      box.querySelectorAll('[data-lease-total-cost]').forEach((element) => {
        const group = element.closest('.local-deals-lease__metric, tr, [data-lease-row], [class*="total"]');
        (group || element).remove();
      });

      Array.from(box.querySelectorAll('*')).forEach((element) => {
        const text = ownText(element);
        if (!text) return;
        if (text === 'CASH PRICE') {
          element.textContent = 'SELLING PRICE';
          return;
        }
        if (text === 'INITIAL PAYMENT') {
          element.textContent = '10% DOWN';
          return;
        }
        if (text === 'YOUR PAYMENTS EQUAL THE CASH PRICE') {
          element.textContent = approvedDisclosure;
          element.classList.add('local-deals-lease__equal', 'local-deals-lease__equal--approved');
          return;
        }
        if (text === 'WEEKLY PAYMENT') {
          element.textContent = '52 WEEKLY PAYMENTS';
          return;
        }
        if (rejectedTotalLabels.includes(text)) {
          removeTotalGroup(element, box);
          return;
        }
        if (rejectedExact.has(text)) element.remove();
      });

      const disclosure = box.querySelector('.local-deals-lease__equal--approved');
      if (disclosure) {
        disclosure.textContent = approvedDisclosure;
      } else {
        const body = box.querySelector('.local-deals-lease__body') || box;
        const paragraph = document.createElement('p');
        paragraph.className = 'local-deals-lease__equal local-deals-lease__equal--approved';
        paragraph.textContent = approvedDisclosure;
        body.appendChild(paragraph);
      }
    });
  };

  let queued = false;
  const run = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      window.fwlNormalizeMobileLease(document);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.matchMedia('(max-width: 749px)').addEventListener?.('change', run);
})();